import Store from 'app/redux/store'
import Redux from 'app/interface/redux'
import { bindActions } from 'redux-zero/utils'
import Branch from 'app/interface/data/branch'
import { AxiosResponse } from 'axios'
import { NestAPI } from '../../../../nestapi'

const Master = bindActions(
  store => ({
    init: async (): Promise<void> => {
      const result: AxiosResponse<Branch[]> = await NestAPI.get('branches/all')
      const state: Redux = store.getState()
      store.setState({
        data: {
          ...state.data,
          generic: {
            ...state.data.generic,
            branches: {
              data: result,
              loading: false,
              timestamp: +new Date(),
            },
          },
        },
      })
    },
  }),
  Store
)

export default Master
